import { observer } from 'mobx-react-lite';
import { timeFormat } from 'd3-time-format';

import React from 'react';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { DownloadCsvComponent } from '../../../../../atomic/buttons/downloadCSV/DownloadCsvComponent';
import style from './Executions.module.css';
import { ExecutionsHeader } from './ExecutionsHeader';
import { ExecutionsRow } from './ExecutionsRow';
import { headerList } from './headerList';
import { colors } from '../../../../../../colorVars';

export const Executions = observer(() => {
  const { tradePlanStore } = useWebsocketStore();
  const executions = tradePlanStore.executionsSortByTime;
  const formatDate = timeFormat('%m-%d-%Y');
  const formattedToday = formatDate(new Date());
  return (
    <div className={style.div}>
      <div>
        <DownloadCsvComponent
          headers={headerList}
          data={executions}
          filename={`executions_${formattedToday}.csv`}
          size="15px"
          backgroundColor={colors.blue}
        />
      </div>
      <div className={style.tableContainer}>
        <table className={style.table}>
          <ExecutionsHeader />
          <tbody className={style.tbody}>
            {executions.map((execution) => (
              <ExecutionsRow
                key={
                  execution.symbol +
                  execution.executionTime +
                  execution.underlyingQuoteAtTimeOfFill
                }
                execution={execution}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
});
